import React from 'react';
import { Link } from 'react-router-dom';

function Section({ title, children }) {
  return (
    <section className="space-y-3">
      <h2 className="text-lg font-semibold text-[#d4af37]">{title}</h2>
      <div className="text-[#c0c0c0] text-sm leading-relaxed space-y-2">{children}</div>
    </section>
  );
}

export default function PrivacyPolicyPage() {
  return (
    <div className="min-h-screen bg-[#0a0e17] text-[#f5f5f0] py-16 px-6">
      <div className="max-w-2xl mx-auto space-y-10">
        <div>
          <h1 className="text-3xl font-bold mb-1">Política de Privacidad</h1>
          <p className="text-[#8a8a8a] text-sm">
            Última actualización: abril de 2026 — Conforme al RGPD (Reglamento (UE) 2016/679)
          </p>
        </div>

        <Section title="1. Responsable del tratamiento">
          <p>JOSE URBANEJA</p>
          <p>DRESDEN, Deutschland</p>
          <p>
            Contacto:{' '}
            <a href="mailto:soporte@wearelxi.com" className="text-[#d4af37] hover:underline">
              soporte@wearelxi.com
            </a>
          </p>
        </Section>

        <Section title="2. Datos que recopilamos">
          <p>Recopilamos únicamente los datos necesarios para procesar tus pedidos:</p>
          <ul className="list-disc list-inside space-y-1 ml-2">
            <li>Nombre y apellidos</li>
            <li>Dirección de correo electrónico</li>
            <li>Contraseña (almacenada exclusivamente en forma de hash bcrypt — nunca en texto plano)</li>
            <li>Dirección de envío (solo al realizar un pedido)</li>
            <li>Historial de compras y estado de pedidos</li>
          </ul>
          <p>No recopilamos datos de pago directamente. Los pagos son procesados por Stripe.</p>
        </Section>

        <Section title="3. Base legal del tratamiento">
          <p>
            El tratamiento de tus datos se basa en el <strong>Art. 6.1.b RGPD</strong> — necesario para
            la ejecución de un contrato del que el interesado es parte (procesamiento del pedido,
            gestión de la cuenta y entrega del producto).
          </p>
          <p>
            El almacenamiento del correo electrónico para comunicaciones transaccionales (confirmación
            de pedido, restablecimiento de contraseña) se basa igualmente en el Art. 6.1.b RGPD.
          </p>
        </Section>

        <Section title="4. Período de conservación de datos">
          <p>
            Los datos de tu cuenta se conservan mientras la cuenta esté activa. Si solicitas la
            eliminación de tu cuenta, borraremos tus datos personales en un plazo de 30 días, salvo
            obligación legal de conservación (por ejemplo, registros contables obligatorios durante
            10 años conforme al § 257 HGB alemán).
          </p>
        </Section>

        <Section title="5. Tus derechos (Arts. 15–22 RGPD)">
          <ul className="list-disc list-inside space-y-1 ml-2">
            <li><strong>Acceso</strong> — puedes solicitar una copia de tus datos personales.</li>
            <li><strong>Rectificación</strong> — puedes corregir datos inexactos desde tu perfil.</li>
            <li><strong>Supresión</strong> — puedes solicitar el borrado de tu cuenta y datos.</li>
            <li><strong>Portabilidad</strong> — puedes solicitar tus datos en formato estructurado.</li>
            <li><strong>Oposición</strong> — puedes oponerte al tratamiento en cualquier momento.</li>
          </ul>
          <p>
            Para ejercer cualquiera de estos derechos, escríbenos a{' '}
            <a href="mailto:soporte@wearelxi.com" className="text-[#d4af37] hover:underline">
              soporte@wearelxi.com
            </a>
            .
          </p>
        </Section>

        <Section title="6. Derecho de reclamación">
          <p>
            Tienes derecho a presentar una reclamación ante la autoridad supervisora de protección de
            datos competente. En Alemania:
          </p>
          <p>
            <strong>Der Bundesbeauftragte für den Datenschutz und die Informationsfreiheit (BfDI)</strong>
            <br />
            Husarenstraße 30, 53117 Bonn
            <br />
            <a
              href="https://www.bfdi.bund.de"
              target="_blank"
              rel="noopener noreferrer"
              className="text-[#d4af37] hover:underline"
            >
              www.bfdi.bund.de
            </a>
          </p>
        </Section>


        <p className="text-[#8a8a8a] text-sm border-t border-[#2a3444] pt-6">
          <Link to="/impressum" className="text-[#d4af37] hover:underline">
            Impressum
          </Link>{' '}
          ·{' '}
          <Link to="/cookies" className="text-[#d4af37] hover:underline">
            Política de Cookies
          </Link>
        </p>
      </div>
    </div>
  );
}
